import { 
  MdListAlt
} from "react-icons/md";

const operaciones = {
  id: 'operaciones-group',
  type: 'group',
  roles: [1,200],
  breadcrumbs: false,
  children: [
    {
      id: 'pedidos-por-autorizar',
      title: "Pedidos por autorizar",
      type: 'item',
      breadcrumbs: false,
      icon: MdListAlt,
      url: '/operaciones/pedidos-por-autorizar',
      roles: [1,200]
    },
    
  ]
};

export default operaciones;
